export default "/images/3d3352a792da549703a9e27d7773ac0a.png";